import React,{useRef, useState} from 'react'
import {Row,Col} from 'react-bootstrap'
import { useDispatch} from 'react-redux'
import { zapisKonkurs,delKonkurs } from '../Magazyn/kreatorAkcji'
import DataKonkurs from '../Komponenty/dataKonkursu'
import LogowanieKonkurs from '../OknaModal/logowanieKonkurs'

import KonkursAktywny from './konkurs_aktywny'
import {useQuery} from "@apollo/client"
import { GET_AktywneKonkursy} from "../Graphql/query"

const AktywneKonkursy  = () => {
  const [widok,setWidok] = useState('K')
   const dispach = useDispatch()
   const zmienne = useRef({variables : {status: 'A'},fetchPolicy: 'network-only'})

   const add_Konkurs = (dane) => {
    dispach(delKonkurs(dane))
    dane.aktywne_konkursy.map(konkurs => dispach(zapisKonkurs(konkurs)) )
   }

   //const token = sessionStorage.getItem('token')
   const {data,loading,error} = useQuery(GET_AktywneKonkursy,zmienne.current)
   if (loading) { return <p>Wczytywanie danych</p>} else {add_Konkurs(data)}
   if (error) { return <p>Błąd połacznia z bazą danych</p>}
        return(
        <Row>
            {widok === 'K' && 
            <div>
              <Row>
                <Col xs={12}><h2 className='napis'> Lista Konkursów </h2></Col>
              </Row>
              <Row>
              {data.aktywne_konkursy.map(konkurs => (
                konkurs.status_konkursu === 'A' ?
                <KonkursAktywny key={konkurs.id_konkursu} konkurs={konkurs} funkcjaWidok={setWidok}/> : ''
                            ))
                          }
              </Row> </div>}
              {widok === 'D' && <DataKonkurs funkcjaWidok={setWidok}/>}
              {widok === 'L' && <LogowanieKonkurs tryb="L" funkcjaWidok={setWidok}/>}
              {widok === 'W' && <LogowanieKonkurs tryb="W" funkcjaWidok={setWidok}/>} 
    </Row>
        )
}

export default AktywneKonkursy